export default {
  gutterBottom: {
    marginBottom: '1rem',
  },
};
